<!-- eslint-disable max-len -->
<template>
  <div class="properties-field-content">
    <!-- Title -->
    <div class="section-field input-field pb-0 border-0">
      <div class="configuration-section">
        <h4 class="configuration-section-title">General</h4>
        <b-form :class="{'error-input' : $v.dataSetup.title.$error}">
          <label> Title </label>
          <j-input
            v-model="dataSetup.title"
            :error-required="$v.dataSetup.title.$error"
            placeholder="Type title for this component"/>
        </b-form>
      </div>
    </div>

    <!-- View -->
    <div class="section-field input-field">
      <div
        :class="{'error-input' : $v.dataSetup.selected_view.$error}"
        class="configuration-section"
      >
        <h4 class="configuration-section-title">Primary View</h4>
        <p class="title-configuration-section-desc">
          Choose an action to be used for this action and a connection to a third party.
        </p>

        <!-- List view web -->
        <p class="title-configuration-section-desc-gray mb-1">
          Desktop
        </p>
        <div class="div-view mb-3">
          <div
            v-for="view in list_view"
            :key="view.id"
            :class="{
              'active': dataSetup.selected_view && dataSetup.selected_view.id === view.id,
              'disabled': !view.hasSetup
            }"
            class="view"
            @click="selectView(view, true)"
          >
            <img
              v-if="dataSetup.selected_view && dataSetup.selected_view.id === view.id"
              :src="require(`@/assets/new-form-ui/icon-active/${view.icon}.svg`)"
            >
            <img
              v-else
              :src="require(`@/assets/new-form-ui/icon/${view.icon}.svg`)"
            >
            <span>{{ view.name }}</span>
          </div>
        </div>

        <!-- List view mobile -->
        <p class="title-configuration-section-desc-gray mb-1">
          Mobile Apps
        </p>
        <div class="div-view">
          <div
            v-for="view in list_view_small"
            :key="view.id"
            :class="{
              'active': dataSetup.selected_view_small && dataSetup.selected_view_small.id === view.id,
              'disabled': !view.hasSetup
            }"
            class="view"
            @click="selectView(view, false)"
          >
            <img
              v-if="dataSetup.selected_view_small && dataSetup.selected_view_small.id === view.id"
              :src="require(`@/assets/new-form-ui/icon-active/${view.icon}.svg`)"
            >
            <img
              v-else
              :src="require(`@/assets/new-form-ui/icon/${view.icon}.svg`)"
            >
            <span>{{ view.name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import jwtDecode from 'jwt-decode';
import { required } from 'vuelidate/lib/validators';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => null,
    },
    dataComponent: {
      type: Object,
      default: () => null,
    },
    dataEdit: {
      type: Object,
      default: () => null,
    },
    pagesId: {
      type: Number,
      default: 0,
    },
    isMultiple: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isFirstLoad: true,
      isLoading: true,
      dataSetup: {
        title: '',
        component: null,
        selected_view: null,
        selected_view_small: null,
      },
      list_view: [],
      list_view_small: [],
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
    };
  },

  created() {
    if (!this.dataEdit) {
      this.getViewData(this.dataComponent);
      this.dataSetup.component = this.dataComponent;
    } else {
      const info = JSON.parse(this.dataEdit.info);
      this.dataSetup.title = this.dataEdit.name;
      const params = {
        limit: 1,
        page: 1,
        filter: JSON.stringify({ id: info.form_ui_id }),
      };

      const service = this.isMultiple ? this.findMultiFormUi : this.findFormUi;
      service(params).then((res) => {
        if (res) {
          const dataFormUi = res[0];
          dataFormUi.label = dataFormUi.name;
          this.dataSetup.component = dataFormUi;
          this.dataSetup.selected_view = {
            id: info.default_view,
            name: info.default_view.replace(/_/g, ' ').replace(/^./, info.default_view[0].toUpperCase()),
          };
          if (info.default_view_small) {
            this.dataSetup.selected_view_small = {
              id: info.default_view_small,
              name: info.default_view_small.replace(/_/g, ' ').replace(/^./, info.default_view_small[0].toUpperCase()),
            };
          }
          this.getViewData(dataFormUi);
        }
      });
    }
  },

  methods: {
    ...mapActions('jStoreApplication', ['getDetailForm']),
    ...mapActions('jStoreFormUi', ['findFormUi', 'findMultiFormUi']),

    getViewData(formUi) {
      const notIncluded = ['kanban_card_view', 'kanban_table_view', 'report_view', 'map_view', 'chart_view', 'import_view'];
      if (this.dataComponent.type !== 'form_ui') notIncluded.push('detail_view');
      const filtered = Object.keys(formUi).filter(key => key.includes('view') && !notIncluded.includes(key));

      const filteredList = filtered.map(el => ({
        id: el,
        name: el.replace('_view', '').replace(/_/g, ' ').replace(/^./, el[0].toUpperCase()).replace('requester', 'Requester')
          .replace('approver', 'Approver'),
        icon: el.replace('_view', '').split('_')[0],
        hasSetup: !!formUi[el],
      }));

      this.list_view = filteredList.filter(e => !e.id.includes('list'));
      this.list_view_small = filteredList;
      this.list_filter_column = [];

      setTimeout(() => {
        if (this.isFirstLoad) this.isFirstLoad = false;
      }, 500);
    },

    selectView(payload, isWeb) {
      if (payload.hasSetup) {
        const data = {
          id: payload.id,
          label: `${payload.name} view`,
          name: `${payload.name} view`,
        };
        if (isWeb) this.dataSetup.selected_view = data;
        else this.dataSetup.selected_view_small = data;
      }
    },

    // eslint-disable-next-line consistent-return
    getData() {
      this.$v.dataSetup.$touch();
      if (!this.$v.dataSetup.$error) {
        const dataField = {
          form_ui_id: this.dataSetup.component.id,
          default_view: this.dataSetup.selected_view.id,
          default_view_small: this.dataSetup.selected_view_small.id,
        };
        const data = {
          value_id: '0',
          pages_id: `${this.pagesId}`,
          name: this.dataSetup.title,
          component_master_id: this.dataMaster.id,
          info: JSON.stringify(dataField),
          type_platform: 1,
        };
        if (this.dataEdit) data.order = this.dataEdit.order;
        return data;
      }
    },
  },

  validations: {
    dataSetup: {
      title: {
        required,
      },
      component: {
        required,
      },
      selected_view: {
        required,
      },
      selected_view_small: {
        required,
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/application-manager/detail/app-tabs/forms/jExpManagerForm.vue